import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';
import { BusinessAccountJobylonConnectionItem } from './type';

const fetchJobylonConnection = async (businessAccountId: string): Promise<BusinessAccountJobylonConnectionItem> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<BusinessAccountJobylonConnectionItem>(
        `business-accounts/${businessAccountId}/connectors/jobylon`,
    );

export const BusinessAccountJobylonConnectionGateway = {
    fetchJobylonConnection,
};
